// Какие слои у активной страны действительно чем-то заполнены.
//
// Каталог слоёв (layers-config.ts) один на весь продукт и описывает то, что
// умеет рисовать фронтенд, а не то, что собрала конкретная страна. До этого
// хука переключатель показывал все двадцать слоёв кому угодно, а признак
// «данных нет» был захардкоженным множеством из одного элемента ('income').
// Испанский пользователь видел в списке аренду, продажу, интернет, снежные
// дни и налог IRPEF — всё это рисовалось сплошным серым.
//
// Поле meta.layers для этого не годится, хотя выглядит предназначенным: его
// не читает ни одна строка фронтенда, а у Италии оно исторически заполнено
// другими идентификаторами (snow_days против snow, hospital_km против
// hospital). Источник истины здесь — сами данные.

import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queries } from '@/data';
import type { ComuneFull } from '@/data';
import { LAYERS_BY_ID } from './layers-config';

// Выборка, а не весь датасет: слой либо заполнен по стране, либо пуст, и
// первые сотни единиц отвечают на это так же надёжно, как восемь тысяч.
// Единицы берутся подряд из индекса — он строится по порядку файла, то есть
// по коду, что даёт разные регионы, а не один угол страны.
const SAMPLE = 400;

export function useAvailableLayers(): Set<string> {
  const { data: meta } = useQuery(queries.meta());
  const version = meta?.version ?? '';
  const { data: fullIndex } = useQuery({ ...queries.fullIndex(version), enabled: !!version });

  return useMemo(() => {
    const present = new Set<string>();
    if (!fullIndex) return present;

    const sample: ComuneFull[] = [];
    for (const unit of fullIndex.byIstat.values()) {
      sample.push(unit);
      if (sample.length >= SAMPLE) break;
    }

    for (const layer of Object.values(LAYERS_BY_ID)) {
      for (const unit of sample) {
        const v = layer.getValue(unit);
        if (v !== null && Number.isFinite(v)) {
          present.add(layer.id);
          break;
        }
      }
    }
    return present;
  }, [fullIndex]);
}
